import type { InferGetStaticPropsType } from 'next';
import type { ArtistPagePublishedProps } from '@/shared/fetchStaticData';
import { fetchArtistPageStaticData } from '@/shared/fetchStaticData';
import { ArtistPageLayout } from '@/components/Layout';
import { TourInfo } from '@imus/artist-page-template';
import { ComingSoon } from '@/components/ComingSoon';

export function TourPage({
  data,
  slug,
  fileBaseUrl,
}: ArtistPagePublishedProps) {
  // _props: InferGetStaticPropsType<typeof getStaticProps>
  return (
    <ArtistPageLayout data={data} pageId={slug} fileBaseUrl={fileBaseUrl}>
      <TourInfo
        tourEvents={data.tour.events}
        tourHighlight={data.tour.splash}
        locale={data.locale}
      />
    </ArtistPageLayout>
  );
}

export default function Page({
  data,
  ...props
}: InferGetStaticPropsType<typeof getStaticProps>) {
  if (data.published) {
    return <TourPage data={data} {...props} />;
  }
  return <ComingSoon data={data} />;
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export const getStaticProps = fetchArtistPageStaticData;
